import {DistributedRewardResponse, PromoTokenType} from "@devour/client";
import {FC} from "react";
import PromoTokenCouponCodeModal
    from "@/components/modals/promoToken/PromoTokenCouponCodeModal";
import PromoTokenExternalUrlModal
    from "@/components/modals/promoToken/PromoTokenExternalUrlModal";
import PromoTokenQrCodeModal from "@/components/modals/promoToken/PromoTokenQrCodeModal";
import {useGetPromoToken} from "@/hooks/useGetPromoToken";

interface Props {
    reward: DistributedRewardResponse;
    isOpen: boolean;
    onClose: () => void;
}

const PromoTokenWonModal: FC<Props> = ({isOpen, onClose, reward}) => {

    const {data: promoToken} = useGetPromoToken(reward.promoTokenId);

    switch (promoToken?.type) {
        case PromoTokenType.COUPON_CODE:
            return (
                <PromoTokenCouponCodeModal
                    description={promoToken.description}
                    couponCode={reward.couponCode}
                    isOpen={isOpen}
                    toggle={onClose}
                />
            );
        case PromoTokenType.EXTERNAL_URL:
            return (
                <PromoTokenExternalUrlModal
                    description={promoToken.description}
                    distributedRewardId={reward.id}
                    isOpen={isOpen}
                    toggle={onClose}
                />
            );
        case PromoTokenType.QR_CODE:
            return (
                <PromoTokenQrCodeModal
                    description={promoToken.description}
                    targetUrl={reward?.targetUrl}
                    qrImageUrl={reward?.qrImageUrl}
                    isBranded={promoToken?.isBranded}
                    isOpen={isOpen}
                    toggle={onClose}
                />
            );
        default:
            return null;
    }

};

export default PromoTokenWonModal;